<template>
  <validation-observer ref="priceCard">
    <b-card title="Fiyat Bilgisi">
      <b-row
        v-for="(item,key) in dataList"
        :key="key"
      >
        <b-col
          v-for="(price,index) in item.prices"
          :key="index"
          cols="12"
          class="mb-1"
        >
          <div
            class="text-secondary font-weight-bold"
          >
            {{ price.title }}
          </div>
          <div class="font-italic text-muted font-small-2">
            {{ price.sub_title }}
          </div>
          <price-item
            :key-number="key"
            :price-key-number="index"
          />
        </b-col>
      </b-row>
      <b-card-footer class="pl-0 pr-0 pb-0">
        <b-button
          variant="danger"
          :disabled="dataList.length === 0"
          @click="submitForm"
        >
          <FeatherIcon icon="SaveIcon" />
          Kaydet
        </b-button>
      </b-card-footer>
    </b-card>
  </validation-observer>
</template>
<script>
import {
  BCard, BRow, BCol, BCardFooter, BButton,
} from 'bootstrap-vue'
import PriceItem from '@/views/Products/elements/PriceCard/PriceItem.vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { ValidationObserver, localize } from 'vee-validate'
import { required } from '@validations'

export default {
  name: 'PriceCard',
  components: {
    BButton,
    BCardFooter,
    BCard,
    BRow,
    BCol,
    PriceItem,
    ValidationObserver,
  },
  data() {
    return {
      required,
    }
  },
  computed: {
    dataList() {
      return this.$store.getters['productPrices/dataList']
    },
    saveData() {
      return this.$store.getters['productPrices/dataSaveStatus']
    },
  },
  watch: {
    saveData(val) {
      if (val.status === true) {
        this.showToast({
          variant: 'success', title: 'İşlem Başarılı!', icon: 'CheckIcon', text: val.message,
        })
        this.getData()
      } else if (val.status === false) {
        this.showToast({
          variant: 'danger', title: 'İşlem Hatası!', icon: 'XIcon', text: val.message,
        })
      }
      this.$store.commit('products/SET_LOADING', false)
    },
  },
  created() {
    this.getData()
    localize('tr')
  },
  methods: {
    getData() {
      if (this.$route.params.id) {
        this.$store.commit('products/SET_LOADING', true)
        this.$store.dispatch('productPrices/getDataList', this.$route.params.id)
          .then(response => {
            if (response) {
              this.$store.commit('products/SET_LOADING', false)
            }
          })
      }
    },
    submitForm() {
      this.$refs.priceCard.validate().then(success => {
        if (success) {
          this.$store.commit('products/SET_LOADING', true)
          this.$store.dispatch('productPrices/saveData', this.dataList)
        } else {
          this.showToast({
            title: 'Uyarı!',
            icon: 'XIcon',
            text: 'Lütfen tüm alanları doldurun.',
            variant: 'danger',
          })
        }
      })
    },
    showToast(params) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: params.title,
          icon: params.icon,
          text: params.text,
          variant: params.variant,
        },
      }, {
        position: 'bottom-center',
      })
      return true
    },
  },
}
</script>
<style scoped>
.primary-title{
  padding: 10px;
  margin-bottom: 5px;
}
</style>
